import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_COMMENT_CATEGORIES_LIST = "GET_COMMENT_CATEGORIES_LIST";

export const service = async (data) => {
  data.entityType="Denial Predictor";
  const options: object = {
    url: "/Api/Comments/GetCommentCategories",
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",},
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_COMMENT_CATEGORIES_LIST, service, mock);
